import React from 'react';
import TradeInput from '../components/TradeInput';

const AddTrades = () => (
  <>
    <TradeInput />
  </>
);

export default AddTrades;
